/** @format */

import { HeaderCheckBoxSelectListElement } from './listTableHeader/HeaderCheckBoxSelectList';

const _ = require('underscore');

export const iccidMvnoStatusIdInt = {
    NOT_SET: -1,
    UNKNOW: 0,
    PREACTIVATED: 1,
    ACTIVE: 2,
    ZERO_CREDIT: 3,
    RESTRICTED: 4,
    RESTRICTED2: 5,
    BLOCK_50: 50,
    CANCELLED: 8,
    BLOCK_98: 98,
    BLOCK_99: 99,
    FAKE_CHANGE_PRODUCT: 999,
};

export const iccidMvnoStatusI18n = {
    NOT_SET: 'pools:state.not_set',
    UNKNOW: 'pools:state.unknow',
    PREACTIVATED: 'pools:state.preactivated',
    ACTIVE: 'pools:state.active',
    ZERO_CREDIT: 'pools:state.zero_credit',
    RESTRICTED: 'pools:state.restricted',
    RESTRICTED2: 'pools:state.restricted2',
    BLOCK_50: 'pools:state.block_50',
    CANCELLED: 'pools:state.cancelled',
    BLOCK_98: 'pools:state.block_98',
    BLOCK_99: 'pools:state.block_99',
    FAKE_CHANGE_PRODUCT: 'pools:state.fake_change_product',
};

export class IccidMvnoStatusHelper {
    private readonly list: Array<HeaderCheckBoxSelectListElement> = [
        { value: iccidMvnoStatusIdInt.ACTIVE, name: iccidMvnoStatusI18n.ACTIVE },
        { value: iccidMvnoStatusIdInt.BLOCK_99, name: iccidMvnoStatusI18n.BLOCK_99 },
        { value: iccidMvnoStatusIdInt.RESTRICTED2, name: iccidMvnoStatusI18n.RESTRICTED2 },
        { value: iccidMvnoStatusIdInt.BLOCK_98, name: iccidMvnoStatusI18n.BLOCK_98 },
        { value: iccidMvnoStatusIdInt.RESTRICTED, name: iccidMvnoStatusI18n.RESTRICTED },
        { value: iccidMvnoStatusIdInt.PREACTIVATED, name: iccidMvnoStatusI18n.PREACTIVATED },
        { value: iccidMvnoStatusIdInt.CANCELLED, name: iccidMvnoStatusI18n.CANCELLED },
        { value: iccidMvnoStatusIdInt.ZERO_CREDIT, name: iccidMvnoStatusI18n.ZERO_CREDIT },
        { value: iccidMvnoStatusIdInt.FAKE_CHANGE_PRODUCT, name: iccidMvnoStatusI18n.FAKE_CHANGE_PRODUCT },
    ];

    private static readonly listStorage: Array<HeaderCheckBoxSelectListElement> = [
        { value: iccidMvnoStatusIdInt.ACTIVE, name: iccidMvnoStatusI18n.ACTIVE },
        { value: iccidMvnoStatusIdInt.BLOCK_99, name: iccidMvnoStatusI18n.BLOCK_99 },
        { value: iccidMvnoStatusIdInt.RESTRICTED2, name: iccidMvnoStatusI18n.RESTRICTED2 },
        { value: iccidMvnoStatusIdInt.BLOCK_98, name: iccidMvnoStatusI18n.BLOCK_98 },
        { value: iccidMvnoStatusIdInt.RESTRICTED, name: iccidMvnoStatusI18n.RESTRICTED },
        { name: iccidMvnoStatusI18n.NOT_SET, value: iccidMvnoStatusIdInt.NOT_SET },
        { value: iccidMvnoStatusIdInt.PREACTIVATED, name: iccidMvnoStatusI18n.PREACTIVATED },
        { value: iccidMvnoStatusIdInt.CANCELLED, name: iccidMvnoStatusI18n.CANCELLED },
        { value: iccidMvnoStatusIdInt.ZERO_CREDIT, name: iccidMvnoStatusI18n.ZERO_CREDIT },
    ];

    getList = (): Array<HeaderCheckBoxSelectListElement> => {
        return this.list;
    };

    getListToStorage = (): Array<HeaderCheckBoxSelectListElement> => {
        return IccidMvnoStatusHelper.listStorage;
    };

    getName = (status: number): string | null => {
        const obj = _.find(this.getListToStorage(), (st: HeaderCheckBoxSelectListElement) => {
            return st.value === status;
        });
        if (obj) {
            return obj.name;
        }
        return null;
    };
}
